import { render } from "./ItemNav.vue?vue&type=template&id=72f1233e"
import script from "./ItemNav.vue?vue&type=script&lang=js"
export * from "./ItemNav.vue?vue&type=script&lang=js"

import "./ItemNav.vue?vue&type=style&index=0&id=72f1233e&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__